import { ArrowLeftCircle2Icon, ArrowRightCircleIcon, Flex, TagPriceActive, TagPriceDefault2, Text } from '@pancakeswap/uikit'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Swiper as SwiperType } from 'swiper';
import BigNumber from 'bignumber.js';
import { BrandItem, productType } from 'state/giftCards/type';
import { PAGE_SIZE, UNIT_TOKEN } from 'config';
import CardItem from './Card';
import { CustomPaginate2 } from './CustomPaginate2';

interface Props {
    viewTag:string,
    setViewTag:(newValue: string) => void,
    priceItem?:string,
    handleSelectPrice:(newValue: BrandItem) => void
    handleSelectCard:(newValue: BrandItem) => void
    brandItem:BrandItem[],
    sortBrandItemOne: BrandItem[],
    sortBrandItemTwo: BrandItem[]
    activeItem: productType,
    isDefaultBrand:boolean,
    isDiffercent:boolean,
    isResultFilterProvince:boolean
}

const GiftCardList:React.FC<Props> = ({
    viewTag,
    setViewTag,
    priceItem,
    handleSelectPrice,
    handleSelectCard,
    brandItem,
    sortBrandItemOne,
    sortBrandItemTwo,
    activeItem,
    isDefaultBrand,
    isDiffercent,
    isResultFilterProvince
}) => {
    const sliderSettingsCard = {
        320: {
          slidesPerView: 1,
          spaceBetween: 4,
        },
        680: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 4,
        },
        1366: {
            slidesPerView: 3,
            spaceBetween: 3,
        },
    };
    const swiperRef = useRef<SwiperType>();
    const [itemOffset, setItemOffset] = useState(0);
    const [currentItem, setCurrentItems] = useState<any>([]);
    const total = Math.ceil(sortBrandItemTwo?.length);

    useEffect(() => {
        const endOffset = itemOffset + PAGE_SIZE;
        setCurrentItems(sortBrandItemTwo?.slice(itemOffset, endOffset));
    }, [itemOffset, sortBrandItemTwo]);
    const resultListByAddress = () => {
        return Array.from(new Set(sortBrandItemOne?.map(s => s?.price?.toLowerCase())))
            .map((item) => {
                return {
                    item,
                    ...sortBrandItemOne?.find((it) => it?.price?.toLowerCase() === item?.toLowerCase()),
                }
            }
        )
    }
    const resultReduceData = resultListByAddress()
    
    return (
        <Flex width="100%" alignItems="center" justifyContent="space-between">
            {
                viewTag === '1' ?
                <>
                {
                    isResultFilterProvince && (
                        <CsListTagPrice>
                            {
                                resultReduceData?.map((item) => {
                                    const currentTime = Math.floor(new Date().getTime() / 1000)
                                    return(
                                        <Card onClick={() => handleSelectPrice(item)}>
                                            <CsFlexCard width="100%" alignItems="center" flexDirection="column">
                                                {
                                                    (Number(item?.is_promo) === 2 && ((Number(currentTime) > Number(item?.start_promo)) && (Number(currentTime) < Number(item?.end_promo)))) ?
                                                        <CsTextCard fontWeight="700" color={new BigNumber(priceItem).isEqualTo(Number(item?.price)) ? 'white !important' : 'primary'}>
                                                            {Number(item?.price_promo).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}1
                                                        </CsTextCard>
                                                    : ''
                                                }

                                                <>
                                                    {
                                                        isDefaultBrand ?
                                                        <TextPromotion color='primary' isPromo={Number(item?.is_promo) === 2}>
                                                            {Number(item?.price).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}2
                                                        </TextPromotion>
                                                        :
                                                        <TextPromotion isPromo={Number(item?.is_promo) === 2} color={new BigNumber(priceItem).isEqualTo(Number(item?.price)) ? 'white !important' : 'primary'}>
                                                            {Number(item?.price).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}
                                                        </TextPromotion>
                                                    }
                                                </>
                                            </CsFlexCard>
                                            <CsTagPrice>
                                                {
                                                    isDefaultBrand ? 
                                                        <TagPriceDefault2 width="100%"/> 
                                                    : 
                                                    <>
                                                        {(new BigNumber(priceItem).isEqualTo(item?.price)) ?
                                                            <TagPriceActive width="100%"/>
                                                            :
                                                            <TagPriceDefault2  width="100%"/>
                                                        }
                                                    </>
                                                }
                                            </CsTagPrice>
                                        </Card>
                                    )
                                })
                            }
                        </CsListTagPrice>
                    )
                }
                </>
                :
                <>
                {
                    isResultFilterProvince && (
                        <>
                            <Flex height={sortBrandItemTwo?.length !== 0 && "100%"} flexDirection="column" alignItems="center">
                                <CsListCard>
                                        {
                                            currentItem?.map((item, index) => {
                                                return(
                                                    <CardItem
                                                        index={index}
                                                        name={item?.title?.replaceAll('UrBox', 'GiftCards')}
                                                        image={item?.image}
                                                        isPromo={Number(item?.is_promo) === 2}
                                                        startPromo={item?.start_promo}
                                                        endPromo={item?.end_promo}
                                                        pricePromo={item?.price_promo}
                                                        priceOrigin={item?.price}
                                                        unit={UNIT_TOKEN}
                                                        date={item?.expire_duration}
                                                        onClick={() => handleSelectCard(item)}
                                                        activeItem={activeItem}
                                                        itemId={item?.id}
                                                        isDefaultBrand={isDefaultBrand}
                                                    />
                                                )
                                            })
                                        }
                                </CsListCard>
                                {
                                    sortBrandItemTwo?.length !== 0 && (
                                        <CsFlexPagination>
                                            <CustomPaginate2 total={total} pageSize={PAGE_SIZE} setItemOffset={setItemOffset} />
                                        </CsFlexPagination>
                                    )
                                }
                            </Flex>
                            <CsListCardMobile flexDirection="column" width="100%" style={{gap: '1rem'}}>
                                <Flex width="100%" alignItems="center" flexDirection="row" justifyContent="space-between" style={{gap: '1rem'}}>
                                    <Swiper
                                        slidesPerView={5}
                                        pagination={{ clickable: true }}
                                        onSlideChange={() => console.log('slide change')}
                                        onSwiper={(swiper) => console.log(swiper)}
                                        spaceBetween={0}
                                        breakpoints={sliderSettingsCard}
                                        modules={[Navigation]}
                                        onBeforeInit={(swiper) => {
                                            swiperRef.current = swiper;
                                        }}
                                        
                                    >
                                        { sortBrandItemTwo?.map((item, index) => {
                                                return (
                                                    <SwiperSlide>
                                                        {({ isActive }) => (
                                                        <CardItem
                                                            name={item?.brand_name}
                                                            image={item?.image}
                                                            pricePromo={item?.price_promo}
                                                            priceOrigin={item?.price}
                                                            unit={UNIT_TOKEN}
                                                            date={item?.expire_duration}
                                                            index={index}
                                                            onClick={() => handleSelectCard(item)}
                                                            itemId={item?.id}
                                                            activeItem={activeItem}
                                                            isDefaultBrand={isDefaultBrand}
                                                            isActive={Number(activeItem?.price) === Number(item?.price)}
                                                        />
                                                        )}
                                                    </SwiperSlide>
                                                )
                                            })
                                        }
                                    </Swiper>
                                </Flex>
                                {
                                    sortBrandItemTwo?.length !== 0 && (
                                        <Flex flexDirection="row" width="100%" justifyContent="center" style={{gap: '1rem'}}>
                                            <CsFlexNext onClick={() => swiperRef.current?.slidePrev()}>
                                                <ArrowRightCircleIcon width="32px" style={{cursor:"pointer", transform:"rotate(180deg)"}} />
                                            </CsFlexNext>
                                            <CsFlexNext onClick={() => swiperRef.current?.slideNext()}>
                                                <ArrowLeftCircle2Icon width="32px" style={{cursor:"pointer", transform:"rotate(180deg)"}} />
                                            </CsFlexNext>
                                        </Flex>
                                    )
                                }
                            </CsListCardMobile>
                        </>
                    )
                }

                </>
            }   
    </Flex>
  )
}
const CsFlexCard = styled(Flex)`
    padding: 0 20px;
    @media screen and (min-width:768px) and (max-width: 1000px) {
        padding: 0 40px;
    }
    @media screen and (max-width:600px){
        padding: 0 10px;
    }
`
const CsTextCard = styled(Text)`
        z-index: 10;
        font-size: 20px;
    @media screen and (min-width:768px) and (max-width: 1000px) {
        font-size: 24px;
    }
    @media screen and (max-width:600px) {
        font-size: 18px;
    }
`

const CsListCard = styled(Flex)`
    gap: 2rem;
    width: 100% !important;
    height: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(4, 1fr);
    @media screen and (max-width:768px) {
        display: none;
    }
`
const CsListCardMobile = styled(Flex)`
    display: none;
    .swiper-initialized, .swiper-horizontal, .swiper-pointer-events{
        width: 100%;
        overflow: unset;
    }
    @media screen and (max-width:768px) {
        display: flex;
        gap: 1rem;
    }
`
const CsListTagPrice = styled(Flex)`
    gap: 2rem;
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    align-items: center;
    grid-template-columns: repeat(5, 1fr);
    z-index:0;
    @media screen and (max-width:768px) {
        width: 100%;
        justify-content: center;
        grid-template-columns: repeat(2, 1fr);
    }
`
const CsFlexPagination = styled(Flex)`
        display: flex;
    @media screen and (max-width:768px) {
        display: none;
    }

`
export const Card = styled(Flex)`
    width: 187px;
    height: 74px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @media screen and (max-width:768px) {
        margin: 0 auto;
        height: 120px;
        width: 90%;
    }
    @media screen and (max-width:600px) {
        margin: 0 auto;
        width: 100%;
        height: 74px;
    }
`
export const CsTagPrice = styled(Flex)`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
`
const CsFlexNext = styled(Flex)`
    display: none;
    @media screen and (max-width: 1023px){
        display: flex;
        cursor: pointer;
        width: 40px;
        height: 40px;
        justify-content: center;
        &:active{
            border: 1px solid red;
            border-radius: 50%;
            border: 2px solid ${({ theme }) => theme.colors.backgroundDisabled};
        }
    }
`
export const TextPromotion = styled(Text)<{isPromo?:boolean}>`
    text-decoration: ${({isPromo}) => isPromo ? 'line-through' : 'none'};
    color: ${({theme, isPromo}) => isPromo ? theme.colors.default : theme.colors.primary };
    z-index: 100;
    font-size: ${({isPromo}) => isPromo ? '14px' : '16px'};
    font-weight: ${({isPromo}) => isPromo ? '400' : '700'};
`
export default GiftCardList